import { useStableValue } from '../hooks/useStable';
import { type LazyExoticComponent } from 'react';

type Props = {
    component: LazyExoticComponent<any>;
    props: any;
};

export function StableComponent({ component: Component, props }: Props) {
    const stableProps = useStableValue(props);
    return <Component {...stableProps} />;
}
